import React, { createRef } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import { BaseNotifier } from './baseNotifier'
import BannerNotification from '../elementals/bannerNotification'

class OverlayBannerNotifier extends BaseNotifier {
  constructor() {
    super()
    this._containerDomNode = null
  }

  initialize() {
    const notificationSystem = createRef()

    // attach notification to body, open it via ref
    this._containerDomNode = document.createElement('div')
    document.body.appendChild(this._containerDomNode)
    render(
      <BannerNotification isOverlay ref={notificationSystem} />,
      this._containerDomNode
    )
    super.initialize(notificationSystem)
  }

  open(options) {
    // open the notification system with the options defaulted using based prepareOptions function - may differ in future
    super.open(super.prepareOptions(options))
  }

  destroy() {
    // unmount and remove the container from the body
    if (this._containerDomNode) {
      unmountComponentAtNode(this._containerDomNode)
      document.body.removeChild(this._containerDomNode)
    }

    super.destroy()
  }
}

export { OverlayBannerNotifier }
